import { getOfferSubCategories } from 'redux/modules/offers/selectors';
import { offerCategorySegment } from 'redux/modules/taxonomy/selectors/offers';

const mapSubCategories = (state, props) => {
  const subCategories = getOfferSubCategories(state);
  const mappedCategories = subCategories.map(category => {
    const categoryPath = offerCategorySegment(state, category.categoryId);

    return {
      name: category.name,
      hiddenInNav: category.hiddenInNav,
      search: {
        categoryId: category.categoryId,
      },
      url: categoryPath ? `${props.location.pathname}/${categoryPath}` : '',
    };
  });

  return mappedCategories.filter(
    subCategory => !subCategory.hiddenInNav && subCategory.name && subCategory.url,
  );
};

export default mapSubCategories;
